import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class CreateExcludedAccountCommand extends ModelBase {
    public staticServiceProviderFileGroupingID: number | null = null;

    public accountNumber: string = "";
}